import { render } from "./WaveHeader.vue?vue&type=template&id=510f8dfa&scoped=true"
import script from "./WaveHeader.vue?vue&type=script&lang=js"
export * from "./WaveHeader.vue?vue&type=script&lang=js"

import "./WaveHeader.vue?vue&type=style&index=0&id=510f8dfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510f8dfa"]])

export default __exports__